import { useEffect } from 'react';
import { useLayout } from '../contexts/LayoutContext';

/**
 * Call this hook in any page that should hide the mobile bottom nav.
 * Automatically restores it when the page unmounts.
 */
export function useHideBottomNav() {
  const { setHideBottomNav } = useLayout();
  useEffect(() => {
    setHideBottomNav(true);
    return () => setHideBottomNav(false);
  }, [setHideBottomNav]);
}
